// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"903":"7d3a3688","970":"1cf03785"}[chunkId] + ".js";
};